import { AuthorityType } from '@/types'

export interface UpdateAuthorityNormalRequest {
  authorityType: AuthorityType
  authorityNo: string
}

export function UpdateAuthorityNormalToJSON(
  value: UpdateAuthorityNormalRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_no: value.authorityNo !== '' ? value.authorityNo : undefined
  }
}
